module.exports = __webpack_public_path__ + "static/media/Banner-THANH-THUY.56d31ee3.jpg";